const config = {
    endpoint: 'https:' + (localStorage.endpoint || '//' + window.location.hostname + '/throttlebnpp-0.0.1')
};

export default config;